<template>
  <div class="container-fluid">
    <page-header
      :page="headers.page"
      :actions="headers.actions"
      left-side-class="col-md-8"
      right-side-class="col-xl-4 align-items-end d-flex pb-2 justify-content-end"
    />
    <filter-manager
      v-model="filter.model"
      :filters="filtersConfig"
      :display-advanced="false"
      @search="search"
      @app="getRoles"
    />
    <custom-separator class="my-4" text="Resultados" />
    <template v-if="results.length">
      <result-row
        v-for="item in results"
        :key="`row-${item.id}`"
        :data="item"
        @remove="remove"
        @edit="edit"
      />
      <pagination
        v-if="pagination.totalItemCount > pageSize"
        show-text
        :data="pagination"
        @pagination-go-page="pageChange"
      />
    </template>
    <custom-result-not-found v-else />
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import CustomSeparator from 'custom-separator';
import CustomResultNotFound from 'custom-result-not-found';
import Pagination from 'pagination';

import ResultRow from './components/ResultRow';

import alertMixin from '@/mixin/alert.mixin';
import storeMixin from '@/mixin/storeGenerator';

import { getApplications } from '@/modules/common/code.api.js';
import { getRolesByApp } from '@/modules/user/api';
import {
  searchReorganizations,
  removeReorganization,
} from '@/services/operations/dashboard-management';

const TITLE = 'Reorganizar Dashboard';
const MANAGE_ROUTE = 'reorganize-dahsboard-manage';
const DEFAULT_PAGE_SIZE = 10;

export default {
  name: 'ReorganizeDashboardMain',
  mixins: [alertMixin, storeMixin],
  components: {
    PageHeader,
    FilterManager,
    CustomSeparator,
    CustomResultNotFound,
    Pagination,
    ResultRow,
  },
  data: () => ({
    filter: {
      model: {},
      options: {
        apps: [],
        roles: [],
      },
    },
    pagination: {
      currentPage: 1,
      totalItemCount: 0,
      pageCount: 1,
      count: 0,
    },
    results: [],
  }),
  async mounted() {
    await Promise.all([this.getApps(), this.search()]);
  },
  computed: {
    pageSize() {
      return DEFAULT_PAGE_SIZE;
    },
    headers() {
      return {
        page: {
          icon: 'fas fa-calculator',
          title: TITLE,
          routes: [
            'Inicio',
            'Operaciones',
            'Mantenimiento de Dashboard',
            TITLE,
          ],
        },
        actions: [
          {
            text: 'Regresar',
            icon: 'fas fa-arrow-circle-left',
            variant: 'outline-success',
            click: () => this.$router.back(),
          },
          {
            text: 'Añadir',
            icon: 'fas fa-file-plus',
            variant: 'success',
            click: this.goToManage,
          },
        ],
      };
    },
    filtersConfig() {
      return [
        {
          name: 'app',
          component: 'CustomDropDown',
          options: this.filter.options.apps,
          placeholder: 'Aplicación',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-12 col-md-4',
          clearable: true,
        },
        {
          name: 'role',
          component: 'CustomDropDown',
          options: this.filter.options.roles,
          disabled: !this.filter.model.app,
          placeholder: 'Rol',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-12 col-md-4',
          clearable: true,
        },
      ];
    },
  },
  methods: {
    async pageChange(page) {
      this.pagination.currentPage = page;
      await this.search();
    },
    async search() {
      const params = {
        appId: this.filter.model.app?.id,
        roleId: this.filter.model.role?.id,
        currentPage: this.pagination.currentPage,
        pageSize: this.pageSize,
      };
      const { data } = await searchReorganizations(params);
      this.results = data.data;
      this.pagination = {
        totalItemCount: data.totalItemCount,
        pageCount: data.pageCount,
        currentPage: data.currentPage,
        count: data.count,
      };
    },
    goToManage(id) {
      const route = { name: MANAGE_ROUTE };
      if (id) route.params = { id };
      this.$router.push(route);
    },
    async getApps() {
      const { data } = await getApplications();
      this.filter.options.apps = data.map((x) => ({
        id: x.keyId,
        name: x.name,
      }));
    },
    async getRoles(app) {
      this.filter.model.role = null;
      this.filter.options.roles = [];
      if (!app) return;
      const { data } = await getRolesByApp(app.id);
      this.filter.options.roles = data;
    },
    async remove(id) {
      const confirmed = await this.ShowCancelModal(
        'Confirmacion',
        '¿Estás seguro que desea eliminar la reorganización?',
        'Si',
        'No'
      );
      if (!confirmed) return;
      try {
        await removeReorganization(id);
        await this.search();
      } catch (error) {
        this.ShowToast(error, 'Error al eliminar registro.', 'error');
      }
    },
    edit(id) {
      this.$router.push({
        name: 'reorganize-dahsboard-manage',
        params: { id },
      });
    },
  },
  destroyed() {
    this.persistData();
  },
  beforeRouteEnter(_, from, next) {
    next((vm) => {
      if (from.name == MANAGE_ROUTE) {
        vm.recoveryData();
      } else {
        vm.shouldRecovery = false;
      }
    });
  },
};
</script>

<style lang="scss" scoped></style>
